import { type StandardsOverviewReportData } from 'teacher-ui-client/components/reporting/standards-performance/overview'
import { Band } from 'teacher-ui-client/components/reporting/performance-overview'

export const standardsPerformanceOverview: Omit<StandardsOverviewReportData, 'meta'> = {
  overview: {
    average_lesson_performance: [
      {
        band: Band.Below,
        total_students: 0,
      },
      {
        band: Band.At,
        total_students: 0,
      },
      {
        band: Band.Above,
        total_students: 50,
      },
    ],
    average_lessons_completed_per_student: 3.7,
    average_score_across_standards: 91,
    standards_practiced: 7,
    total_lessons_completed: 183,
    total_students: 50,
  },
}
